import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo10 } from "../../../routes/Module10";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import GuiaDocente from "../../../components/GuiaDocente";
import Imagen from "../../../images/modulo10/fondoespiral.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo10/Actividad 8.mp3";

const Actividad8 = () => {
  const infoUnidad = modulo10.content[0];
  const infoAct = modulo10.content[0].activities[7];
  const crumbs = [
    {
      title: modulo10.title,
      url: "/" + modulo10.url,
    },
    {
      title:
        modulo10.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo10.content[0].activities[8].name}`,
    linkNext: `${modulo10.url}/${modulo10.content[0].path}/${modulo10.content[0].activities[8].path}`,
    titlePrev: `${modulo10.content[0].activities[6].name}`,
    linkPrev: `${modulo10.url}/${modulo10.content[0].path}/${modulo10.content[0].activities[6].path}`,
  };
  const metadata = {
    color: modulo10.color,
    title: `${modulo10.title} - ${infoAct.name}`,
    name: modulo10.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo10.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>
          Con ayuda de tu profesor, profesora o un familiar, llena la
          información sobre los congresistas de tu región.
        </li>
      </ul>

      <div className="row align-items-center justify-content-center mt-2 bg-espiral" style={{backgroundImage: `url(${Imagen})`}}>
        <div className="col-lg-8 col-12">
            <h4>CONGRESISTAS DE MI REGIÓN</h4>
            <li>
              Nombre de mi región:{" "}
              <input type="text" className="form-control d-inline w-200" />
            </li>
            <li>
              Numero de congresistas de mi región:{" "}
              <input type="text" className="form-control d-inline w-200" />
            </li>
            <li>
              Nombre de un o una congresistas de mi región:{" "}
              <input type="text" className="form-control d-inline w-200" />
            </li>
            <li>
              Partido político al que pertenece:{" "}
              <input type="text" className="form-control d-inline w-200" />
            </li>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones y ayude a llenar los datos sobre los congresistas
          de su región.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
